import React from 'react';
import { colors } from '../styles';
import { RGB_Linear_Shade } from '../utils/chart';

const SkyScraper = ({
  active,
  chart_height,
  onClick,
  round,
  shades,
  origin,
  spacing,
  stroke,
  stroke_width,
}) => {
  const s = 0.6;
  const cubes = active.map(({ label, raw, value }, index) => {
    const max_height = value / 2;
    const height = chart_height - (115 + max_height) * s;
    const origin_fix_bases = {
      x: origin.x + index * spacing,
      y: height,
    };

    const base_vertex = {
      y: 29 * s,
      yy: 57 * s,
      yyy: (87 + max_height) * s,
      yyyy: (115 + max_height) * s,
      x: 50 * s,
      xx: 100 * s,
    };

    const base_faces = [
      `M ${origin_fix_bases.x},${origin_fix_bases.y + base_vertex.y} 
        L 
        ${origin_fix_bases.x}, ${origin_fix_bases.y + base_vertex.yyy}
        ${origin_fix_bases.x + base_vertex.x}, ${origin_fix_bases.y +
        base_vertex.yyyy}
        ${origin_fix_bases.x + base_vertex.x}, ${origin_fix_bases.y +
        base_vertex.yy}
        ${origin_fix_bases.x},${origin_fix_bases.y + base_vertex.y}
      z`,

      `M ${origin_fix_bases.x},${origin_fix_bases.y + base_vertex.y} 
        L 
        ${origin_fix_bases.x + base_vertex.x}, ${origin_fix_bases.y +
        base_vertex.yy}
        ${origin_fix_bases.x + base_vertex.xx}, ${origin_fix_bases.y +
        base_vertex.y}
        ${origin_fix_bases.x + base_vertex.x}, ${origin_fix_bases.y}
       ${origin_fix_bases.x},${origin_fix_bases.y + base_vertex.y}
      z`,
      `M ${origin_fix_bases.x + base_vertex.x},${origin_fix_bases.y +
        base_vertex.yy} 
        L 
        ${origin_fix_bases.x + base_vertex.x}, ${origin_fix_bases.y +
        base_vertex.yyyy}
        ${origin_fix_bases.x + base_vertex.xx}, ${origin_fix_bases.y +
        base_vertex.yyy}
        ${origin_fix_bases.x + base_vertex.xx}, ${origin_fix_bases.y +
        base_vertex.y}
        ${origin_fix_bases.x + base_vertex.x},${origin_fix_bases.y +
        base_vertex.yy}
      z
      `,
    ];

    const origin_fix_pyramids = {
      x: origin.x + index * spacing,
      y: height - 17,
    };
    const pyramid_vertex = {
      y: 58 * s,
      yy: 87 * s,
      x: 51 * s,
      xx: 100 * s,
    };

    const pyramid_faces = [
      `M ${origin_fix_pyramids.x + pyramid_vertex.x},${origin_fix_pyramids.y} 
      L 
      ${origin_fix_pyramids.x}, ${origin_fix_pyramids.y + pyramid_vertex.y}
      ${origin_fix_pyramids.x + pyramid_vertex.x}, ${origin_fix_pyramids.y +
        pyramid_vertex.yy}
      z
      `,
      `
       M ${origin_fix_pyramids.x + pyramid_vertex.x},${origin_fix_pyramids.y} 
       ${origin_fix_pyramids.x + pyramid_vertex.x}, ${origin_fix_pyramids.y +
        pyramid_vertex.yy}
      ${origin_fix_pyramids.x + pyramid_vertex.xx},${origin_fix_pyramids.y +
        pyramid_vertex.y}
      z
      `,
    ];
    return (
      <g
        key={index}
        style={{
          cursor: 'pointer',
        }}
        onClick={() => onClick({ raw, label })}
      >
        <g
          style={{
            cursor: 'pointer',
          }}
        >
          {base_faces.map((f, i) => (
            <path
              d={f}
              key={`${i}-face-base`}
              fill={RGB_Linear_Shade((i * 16) / 100, shades)}
            />
          ))}
        </g>
        <g>
          {pyramid_faces.map((f, i) => (
            <path
              d={f}
              key={`${i}-face-pyramid`}
              fill={RGB_Linear_Shade((i * 16) / 100, shades)}
            />
          ))}
        </g>
      </g>
    );
  });

  return (
    <g
      aria-hidden="true"
      stroke={stroke}
      strokeWidth={stroke_width}
      strokeLinecap={round ? 'round' : 'square'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {cubes}
    </g>
  );
};
export default SkyScraper;
